<template>
  <div class="body">
      <Headtow></Headtow>
      <div  id="bj">
        <div id="w-center">
          <div id="Breadcrumb">
            <i class="el-icon-house Breadcrumb-i" ></i>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>会员中心</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!-- 左侧 -->
          <Memberleft></Memberleft>

          <!-- 左侧结束 -->
          <div class="w-products rihgt">
            <div class="Member-right">
                <p class="content-jj">新闻管理</p>
            </div>
            <div class="h-20"></div>
            <div class="w-products rihgt Member-right">
              <div class="member-label DeviceInfos DeviceInfos-w">
                <el-tabs>
                  <el-tab-pane :label="'我的新闻（'+total+'）'">
                    <el-form ref="form" :model="form" label-width="80px">
                      <el-form-item label="标题">
                        <el-input placeholder="请输入标题" v-model="form.title"></el-input>
                      </el-form-item>
                      <el-form-item label="新闻分类">
                        <el-select clearable v-model="form.type" placeholder="新闻分类">
                          <el-option  v-for="(item, index) in type" :key="item.id" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" icon="el-icon-search"  @click="onSubmit(form)" size="medium">搜索</el-button>
                      </el-form-item>
                    </el-form>
                  </el-tab-pane>
                </el-tabs>

              </div>
                <el-button type="warning" icon="el-icon-delete" @click="ondelete">删除</el-button>
                <el-button type="primary" icon="el-icon-edit" size="medium" @click="$router.push('/MemberNewsAdd?memberindex=3')">发布</el-button>
              <el-table
                  v-loading="loading"
                  ref="multipleTable"
                  :data="list"
                  tooltip-effect="dark"
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
                  <el-table-column type="selection" width="55"> </el-table-column>
                  <el-table-column label="分类 " width="120">
                    <template slot-scope="scope">{{ scope.row.type }}</template>
                  </el-table-column>
                  <el-table-column prop="title" label="新闻名称 " width="120"></el-table-column>
                  <el-table-column  label="封面" show-overflow-tooltip>
                     <template slot-scope="scope"><img :src="scope.row.picurl" alt=""></template>
                  </el-table-column>
                  <el-table-column label="发布时间" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.create_time }}</template>
                  </el-table-column>
                  <el-table-column label="状态 " width="120">
                    <template slot-scope="scope">{{ scope.row.status_text }}</template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                      <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="page">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :page-size="8"
                    @current-change="handleCurrentChange"
                    :total="total">
                  </el-pagination>
                </div>



              <div class="h-30"></div>
              <div class="h-30 clear"></div>
              <div class="h-30"></div>
            </div>

          </div>

          <div class="clear"></div>


        </div>
      </div>
       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import memberleft from '@/components/public/memberleft.vue'
export default{
  data(){
    return {
     loading:true,
     activeIndex: '3',
     imageUrl: '',
     page:1,
     total:0,
     form: {
         title: '',
         type:'',
     },
     type:{},
     list: [],
     multipleSelection: []
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Memberleft': memberleft,
  },

  mounted () {
    this.recordapi();
  },
  methods:{

    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Member/MemberNewsList",{'userid':userid,'page':this.page,'title':that.form.title,'type':that.form.type}).then(res => {
          console.log(res);
          if(res.code == 1){
            this.list = res.list.data;
            this.type = res.type;
            this.total = res.list.total
            this.loading = false
          }

        });
    },
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    // 修改
     handleEdit(index, row) {
        console.log();
        this.$router.push({path:'/MemberNewsEdit',query:{id:row.id,memberindex:3}});
      },
    // 删除
      handleDelete(index, row) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.post("/Member/OnMemberNewsListdelete",{'str':row.id}).then(res => {
            this.$message.success(res.msg);
            this.recordapi();
          });

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });


      },
      // 多选删除
      ondelete(){
        var str = '';
        for (var i=0;i<this.multipleSelection.length;i++)
        {
           var str = str+this.multipleSelection[i]['id']+",";
        }
        var str=str.substring(0, str.length - 1);
        console.log(str);

        if(str == ''){
          this.$message.warning('请选择您要删除的数据');
          return;
        }
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.post("/Member/OnMemberNewsListdelete",{'str':str}).then(res => {
            this.$message.success(res.msg);
            this.recordapi();
          });

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    onSubmit(form) {
      var that = this;
      console.log(form)
      this.recordapi();

    },
  }

 }
</script>



// WEBPACK FOOTER //
// src/components/MemberNews.vue